import React from 'react';
import { Wallpaper, Ruler, Album } from 'lucide-react';

/**
 * Секция формы с параметрами обоев
 */
const WallpaperParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  wallpaperTypes
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Wallpaper className="w-5 h-5 mr-2 text-blue-500" />
        Параметры обоев
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип обоев */}
        <div>
          <label htmlFor="wallpaperType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип обоев
          </label>
          <select
            id="wallpaperType"
            name="wallpaperType"
            value={formData.wallpaperType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {wallpaperTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.wallpaperType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.wallpaperType}
            </p>
          )}
        </div>

        {/* Ширина рулона - скрываем для жидких обоев */}
        {formData.wallpaperType !== 'liquid' && (
          <div>
            <label htmlFor="rollWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Ruler className="w-4 h-4 mr-2 text-blue-500" />
              Ширина рулона (см)
            </label>
            <input
              type="text"
              id="rollWidth"
              name="rollWidth"
              value={formData.rollWidth}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.rollWidth ? 'input-error' : ''}`}
              placeholder="Ширина рулона"
            />
            {errors.rollWidth && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.rollWidth}
              </p>
            )}
          </div>
        )}

        {/* Длина рулона - скрываем для жидких обоев */}
        {formData.wallpaperType !== 'liquid' && (
          <div>
            <label htmlFor="rollLength" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Ruler className="w-4 h-4 mr-2 text-blue-500" />
              Длина рулона (м)
            </label>
            <input
              type="text"
              id="rollLength"
              name="rollLength"
              value={formData.rollLength}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.rollLength ? 'input-error' : ''}`}
              placeholder="Длина рулона"
            />
            {errors.rollLength && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.rollLength}
              </p>
            )}
          </div>
        )}

        {/* Раппорт (для обычных обоев) */}
        {formData.wallpaperType !== 'liquid' && (
          <div>
            <label htmlFor="patternRepeat" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Album className="w-4 h-4 mr-2 text-blue-500" />
              Раппорт (см)
            </label>
            <input
              type="text"
              id="patternRepeat"
              name="patternRepeat"
              value={formData.patternRepeat}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.patternRepeat ? 'input-error' : ''}`}
              placeholder="0 = без узора"
            />
            {errors.patternRepeat && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.patternRepeat}
              </p>
            )}
          </div>
        )}
      </div>

      {/* Информация о раппорте */}
      {formData.wallpaperType !== 'liquid' && (
        <div className="mt-4 bg-white dark:bg-gray-800 rounded-md p-3 border border-blue-100 dark:border-blue-800 text-sm">
          <p className="text-gray-700 dark:text-gray-300">
            <span className="font-medium">Раппорт</span> - это расстояние между повторяющимися элементами узора на обоях.
            Если обои без узора, оставьте значение 0. Информацию о раппорте обычно можно найти на упаковке обоев или в их описании.
          </p>
        </div>
      )}

      {/* Информация о жидких обоях */}
      {formData.wallpaperType === 'liquid' && (
        <div className="mt-4 bg-white dark:bg-gray-800 rounded-md p-3 border border-blue-100 dark:border-blue-800 text-sm">
          <p className="text-gray-700 dark:text-gray-300">
            <span className="font-medium">Жидкие обои</span> рассчитываются по площади покрытия.
            Обычно 1 упаковка жидких обоев покрывает 3-4 м². Рекомендуем проверить фактический расход на упаковке конкретного производителя.
          </p>
        </div>
      )}
    </div>
  );
};

export default WallpaperParametersSection;